module.exports = __webpack_public_path__ + "static/cercazone_nordovest1-f4e946209d701762db2ff7c70fe7da3d.jpg";